'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _author = require('../components/author');

var _author2 = _interopRequireDefault(_author);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartTableRow = function (_Component) {
    (0, _inherits3.default)(CartTableRow, _Component);

    function CartTableRow() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CartTableRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CartTableRow.__proto__ || (0, _getPrototypeOf2.default)(CartTableRow)).call.apply(_ref, [this].concat(args))), _this), _this.selectItem = function (event) {
            var dataset = event.target.dataset;
            if (!dataset.productid || !/^[0-9]+$/.test(dataset.productid)) return;

            var selectedRow = dataset.selectedRow === 'true';
            _this.props.selectItem({ productId: parseInt(dataset.productid), originalSelection: selectedRow });
        }, _this.handleChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            if (e.target.value !== _this.props.displayAmount) {
                _this.props.changeAmount({ productId: _this.props.item.productId, amount: e.target.value });
            }
        }, _this.submit = function () {
            _this.cancelDelayedSubmit();
            if (_this.props.item.changed) {
                _this.props.submitChanges({
                    productId: _this.props.item.productId,
                    amount: _this.props.item.amount,
                    keep: true
                });
            }
        }, _this.delayedSubmitHandle = 0, _this.cancelDelayedSubmit = function () {
            if (_this.delayedSubmitHandle) {
                clearTimeout(_this.delayedSubmitHandle);
                _this.delayedSubmitHandle = 0;
            }
        }, _this.handleDelete = function () {
            abp.localization.abpWeb['Cancel'] = 'Káncl';
            abp.message.confirm(Resx.App.CmsPageFileDeleteConfirmation, Resx.Messages.ConfirmDelete, function (isConfirmed) {
                if (isConfirmed) {

                    if (typeof _this.props.onDelete === 'function') {
                        _this.props.onDelete(_this.props.item);
                    } else {
                        _this.props.submitChanges({ cartItemId: _this.props.item.cartItemId, amount: 0 });
                    }
                }
            });
        }, _this.skEnvironment = function () {
            return window.document.body.classList.contains('sk');
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CartTableRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                var self = _this2;

                // handle loading animation
                // just want it trigger once
                (0, _jquery2.default)('#loadingTr', document).remove();

                (0, _jquery2.default)(_this2.refs.quanitySniper).TouchSpin({
                    max: self.props.maxAmountPerItem,
                    buttondown_class: "hide",
                    buttonup_class: "hide"
                }).on('touchspin.on.stopspin', _this2.handleChange).on('mousewheel', function () {
                    var _this3 = this;

                    self.cancelDelayedSubmit();
                    clearTimeout(_jquery2.default.data(this, 'timer'));
                    _jquery2.default.data(this, 'timer', setTimeout(function () {
                        self.handleChange({ target: _this3 });
                    }, 250));
                }).on('click', function () {
                    this.setSelectionRange(0, this.value.length);
                }).on('blur', function () {
                    self.submit();
                });
            }, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            var _pickBy = (0, _pickBy3.default)(this.props.item),
                _pickBy$productId = _pickBy.productId,
                productId = _pickBy$productId === undefined ? '' : _pickBy$productId,
                _pickBy$productName = _pickBy.productName,
                productName = _pickBy$productName === undefined ? '' : _pickBy$productName,
                _pickBy$authors = _pickBy.authors,
                authors = _pickBy$authors === undefined ? [] : _pickBy$authors,
                _pickBy$ean = _pickBy.ean,
                ean = _pickBy$ean === undefined ? '' : _pickBy$ean,
                _pickBy$amount = _pickBy.amount,
                amount = _pickBy$amount === undefined ? '' : _pickBy$amount,
                _pickBy$displayAmount = _pickBy.displayAmount,
                displayAmount = _pickBy$displayAmount === undefined ? '' : _pickBy$displayAmount,
                _pickBy$price = _pickBy.price,
                price = _pickBy$price === undefined ? {} : _pickBy$price,
                _pickBy$isBestseller = _pickBy.isBestseller,
                isBestseller = _pickBy$isBestseller === undefined ? false : _pickBy$isBestseller,
                _pickBy$isSpecialOffe = _pickBy.isSpecialOffer,
                isSpecialOffer = _pickBy$isSpecialOffe === undefined ? false : _pickBy$isSpecialOffe,
                _pickBy$isNew = _pickBy.isNew,
                isNew = _pickBy$isNew === undefined ? false : _pickBy$isNew,
                _pickBy$isRequestedRe = _pickBy.isRequestedReturn,
                isRequestedReturn = _pickBy$isRequestedRe === undefined ? false : _pickBy$isRequestedRe,
                _pickBy$isUpcoming = _pickBy.isUpcoming,
                isUpcoming = _pickBy$isUpcoming === undefined ? false : _pickBy$isUpcoming,
                _pickBy$isFutureRepri = _pickBy.isFutureReprint,
                isFutureReprint = _pickBy$isFutureRepri === undefined ? false : _pickBy$isFutureRepri,
                _pickBy$isReprint = _pickBy.isReprint,
                isReprint = _pickBy$isReprint === undefined ? false : _pickBy$isReprint,
                _pickBy$isDiscounted = _pickBy.isDiscounted,
                isDiscounted = _pickBy$isDiscounted === undefined ? false : _pickBy$isDiscounted,
                _pickBy$commission = _pickBy.commission,
                commission = _pickBy$commission === undefined ? false : _pickBy$commission,
                _pickBy$isCommercialP = _pickBy.isCommercialPriority,
                isCommercialPriority = _pickBy$isCommercialP === undefined ? false : _pickBy$isCommercialP,
                _pickBy$isReedition = _pickBy.isReedition,
                isReedition = _pickBy$isReedition === undefined ? false : _pickBy$isReedition,
                _pickBy$commercialPri = _pickBy.commercialPriority,
                commercialPriority = _pickBy$commercialPri === undefined ? null : _pickBy$commercialPri,
                _pickBy$commissionAmo = _pickBy.commissionAmount,
                commissionAmount = _pickBy$commissionAmo === undefined ? 0 : _pickBy$commissionAmo,
                _pickBy$amountAvailab = _pickBy.amountAvailable,
                amountAvailable = _pickBy$amountAvailab === undefined ? 0 : _pickBy$amountAvailab,
                _pickBy$amountCentral = _pickBy.amountCentralAvailable,
                amountCentralAvailable = _pickBy$amountCentral === undefined ? 0 : _pickBy$amountCentral,
                _pickBy$totalAmountAv = _pickBy.totalAmountAvailable,
                totalAmountAvailable = _pickBy$totalAmountAv === undefined ? 0 : _pickBy$totalAmountAv,
                _pickBy$amountForProc = _pickBy.amountForProcessing,
                amountForProcessing = _pickBy$amountForProc === undefined ? 0 : _pickBy$amountForProc,
                _pickBy$amountOnTheWa = _pickBy.amountOnTheWay,
                amountOnTheWay = _pickBy$amountOnTheWa === undefined ? 0 : _pickBy$amountOnTheWa,
                _pickBy$selectedRow = _pickBy.selectedRow,
                selectedRow = _pickBy$selectedRow === undefined ? false : _pickBy$selectedRow,
                _pickBy$languageCode = _pickBy.languageCode,
                languageCode = _pickBy$languageCode === undefined ? '' : _pickBy$languageCode;

            var _props = this.props,
                _props$readOnly = _props.readOnly,
                readOnly = _props$readOnly === undefined ? false : _props$readOnly,
                canChangeCart = _props.canChangeCart,
                canSeeRabat = _props.canSeeRabat;

            var cssAmountZero = amountOnTheWay === 0 && amountForProcessing === 0 && commissionAmount === 0 ? "amount-zero" : "";
            var showFlag = this.skEnvironment() || (document.getElementById('displayCzechFlags') || {}).value === 'true';
            var flagUrl = './Content/images/svg/flags/1x1/' + languageCode + '.svg';
            var flagLimit = parseInt((/^[0-9]+$/.exec((document.getElementById('flagLimit') || {}).value) || []).pop() || '0');
            var flagCount = 0;

            return _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'table-view--title-name' },
                    _react2.default.createElement(
                        'a',
                        { className: 'title', href: (0, _config2.default)().url.product({ id: productId }) },
                        productName
                    ),
                    _react2.default.createElement('br', null),
                    (0, _intersperse2.default)(authors.map(function (author) {
                        return _react2.default.createElement(_author2.default, { key: 'author_' + author.typeId + '_' + author.id, data: author });
                    }), ", ")
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'product-icon-group', 'data-tooltip-placements': 'right' },
                        isBestseller && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-b product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': 'Bestseller' }) : null,
                        isSpecialOffer && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-a product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:SpecialOffer') }) : null,
                        isNew && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-n product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:New') }) : null,
                        isRequestedReturn && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-v product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:TakeBackDemanded') }) : null,
                        isReedition && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-r product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:IsReedition') }) : null,
                        isUpcoming && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-u product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:Upcoming') }) : null,
                        isFutureReprint && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-fd product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('Common:Reissue') }) : null,
                        isReprint && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-d product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('Common:Reissue') }) : null,
                        isDiscounted && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-s product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:Sale') }) : null,
                        abp.session.commission && !commission && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-f product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:OnlyInvoice') }) : null,
                        isCommercialPriority && flagCount++ < flagLimit ? _react2.default.createElement(
                            'span',
                            { className: 'product-icon product-icon--small', 'data-toggle': 'tooltip',
                                'data-original-title': (0, _localize2.default)('App:CommercialPriority') + ':' + commercialPriority },
                            commercialPriority
                        ) : null,
                        amount > amountAvailable && amount <= totalAmountAvailable && flagCount++ < flagLimit ? _react2.default.createElement('span', { className: 'product-icon product-icon-c product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:LongerDelivery') }) : null,
                        showFlag && languageCode && flagCount++ < flagLimit ? _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement('img', { className: 'product-icon product-icon-lang product-icon--small', src: flagUrl,
                                alt: languageCode, title: languageCode })
                        ) : null
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'small' },
                    ean
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'car-amount' },
                    !readOnly && canChangeCart ? _react2.default.createElement('input', { ref: 'quanitySniper', className: 'quanitySniper', type: 'text',
                        value: displayAmount || amount || '', onChange: this.handleChange }) : amount
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-center small text-nowrap' },
                    _react2.default.createElement(
                        'span',
                        { 'data-toggle': 'tooltip',
                            'data-placement': 'top',
                            'data-original-title': (0, _localize2.default)("App:ProcessingAmount") },
                        _react2.default.createElement(
                            'span',
                            { className: cssAmountZero },
                            amountForProcessing
                        )
                    ),
                    '\xA0\xA0|\xA0\xA0',
                    _react2.default.createElement(
                        'span',
                        { 'data-toggle': 'tooltip',
                            'data-placement': 'top',
                            'data-original-title': (0, _localize2.default)("App:AmountOnTheWay") },
                        _react2.default.createElement(
                            'span',
                            { className: cssAmountZero },
                            amountOnTheWay
                        )
                    ),
                    abp.session.commission ? _react2.default.createElement(
                        'text',
                        null,
                        '\xA0\xA0|\xA0\xA0'
                    ) : null,
                    abp.session.commission ? _react2.default.createElement(
                        'span',
                        { 'data-toggle': 'tooltip',
                            'data-placement': 'top',
                            'data-original-title': (0, _localize2.default)("App:ConsignmentStore") },
                        _react2.default.createElement(
                            'span',
                            { className: cssAmountZero },
                            commissionAmount
                        )
                    ) : null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('hr', null),
                    this.props.showStockAmountSeparately ? _react2.default.createElement(
                        'span',
                        { 'data-toggle': 'tooltip',
                            'data-placement': 'top',
                            'data-original-title': (0, _localize2.default)("App:AmountOnDistributionStock") },
                        _react2.default.createElement(
                            'span',
                            { className: amountAvailable === 0 ? "amount-zero" : "" },
                            this.props.amountAvailableLimit < amountAvailable ? this.props.amountAvailableLimit + '+' : amountAvailable
                        )
                    ) : null,
                    this.props.showStockAmountSeparately ? _react2.default.createElement(
                        'text',
                        null,
                        '\xA0\xA0|\xA0\xA0'
                    ) : null,
                    this.props.showStockAmountSeparately ? _react2.default.createElement(
                        'span',
                        { 'data-toggle': 'tooltip',
                            'data-placement': 'top',
                            'data-original-title': (0, _localize2.default)("App:AmountOnCentralStock") },
                        _react2.default.createElement(
                            'span',
                            { className: amountCentralAvailable == 0 ? "amount-zero" : "" },
                            this.props.amountAvailableLimit < amountCentralAvailable ? this.props.amountAvailableLimit + '+' : amountCentralAvailable
                        )
                    ) : null,
                    this.props.showStockAmountSeparately ? null : _react2.default.createElement(
                        'span',
                        { 'data-toggle': 'tooltip',
                            'data-placement': 'top',
                            'data-original-title': (0, _localize2.default)("App:Amount") },
                        _react2.default.createElement(
                            'span',
                            { className: totalAmountAvailable === 0 ? "amount-zero" : "" },
                            this.props.amountAvailableLimit < totalAmountAvailable ? this.props.amountAvailableLimit + '+' : totalAmountAvailable
                        )
                    )
                ),
                canSeeRabat ? _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    price.totalPrice.percentageDiscount || 0,
                    ' %'
                ) : null,
                _react2.default.createElement(
                    'td',
                    { className: 'nowrap text-right' },
                    _react2.default.createElement(
                        'strong',
                        {
                            className: 'nowrap' },
                        (0, _linksoftAlbatros.formatPrice)(price.unitPrice.standardPrice, _linksoftAlbatros.PriceType.StandardPrice)
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'nowrap' },
                        (0, _linksoftAlbatros.formatPrice)(price.totalPrice.finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPriceWithoutVat)
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'strong',
                        {
                            className: 'nowrap' },
                        (0, _linksoftAlbatros.formatPrice)(price.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'delete' },
                    canChangeCart ? _react2.default.createElement(
                        'a',
                        { title: 'Delete', onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'fa fa-remove' })
                    ) : '',
                    _react2.default.createElement(
                        'div',
                        { className: 'delete-check' },
                        _react2.default.createElement('input', { type: 'checkbox',
                            className: 'selectTableCartItem',
                            key: 'selectTci_' + productId,
                            name: 'selectTci_' + productId,
                            checked: selectedRow
                        }),
                        _react2.default.createElement('label', { htmlFor: 'selectTci_' + productId,
                            onClick: this.selectItem,
                            'data-productid': productId,
                            'data-selected-row': selectedRow
                        })
                    )
                )
            );
        }
    }]);
    return CartTableRow;
}(_react.Component);

CartTableRow.propTypes = {
    maxAmountPerItem: _propTypes2.default.number.isRequired,
    item: _propTypes2.default.object.isRequired,
    submitChanges: _propTypes2.default.func.isRequired,
    changeAmount: _propTypes2.default.func.isRequired,
    canChangeCart: _propTypes2.default.bool.isRequired,
    showStockAmountSeparately: _propTypes2.default.bool.isRequired,
    amountAvailableLimit: _propTypes2.default.number.isRequired,
    selectItem: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
    return {
        maxAmountPerItem: state.cart.maxAmountPerItem,
        showStockAmountSeparately: state.cart.showStockAmountSeparately,
        amountAvailableLimit: state.cart.amountAvailableLimit
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    submitChanges: _actions2.default.submitChanges,
    changeAmount: _actions2.default.changeAmount,
    selectItem: _actions2.default.addSelectedItem
})(CartTableRow);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/CartTableRow.js
// module id = 902
// module chunks = 0